// extracted by mini-css-extract-plugin
export default {"analysisSnippet":"VariationTipCard_analysisSnippet__YiKrH"};